// extracted by mini-css-extract-plugin
export default {"noTweets":"style_noTweets__e-b1c","BookmarksContainer":"style_BookmarksContainer__Wioq7"};